
(function() {

    'use strict';
   
    var ItxProductCarrouselCmp = {
        bindings: {
            product: '<',
            arrayProducts: '<',
            inViewport:'<',
            slidesPerView: '<',
            onProductClick: '&',
            locationSize: '<',
            place: '<',
            layout: '<'
        },
        controller: ItxProductCarrouselCtrl,
        templateUrl: 'product-carrousel.component.html'
    };

    angular.module('itxApp.common')
        .component('itxProductCarrousel', ItxProductCarrouselCmp);

    ItxProductCarrouselCtrl.$inject = [
        'ItxConstants',
        'ItxScreenSizeSvc',
        'ItxConfigurationSvc',
        'Product',
        'ItxUtilsFct'
    ];

    function ItxProductCarrouselCtrl(
        ItxConstants,
        ItxScreenSizeSvc,
        ItxConfigurationSvc,
        Product,
        ItxUtilsFct
    ){

        var _this = this;

        if(!_this.slidesPerView){
            _this.swiperDinamicSlides = _this.arrayProducts.length;
        } else {
            _this.swiperDinamicSlides = _this.slidesPerView;
        }

        _this.debugActive = false;
        _this.isMobile = ItxScreenSizeSvc.isDeviceMobile();
        _this.imageSize = 'grid';
            
        _this.swiperOptions = {
            effect: 'slide',
            speed:600,
            spaceBetween: 16,
            uniqueNavElements: true,
            slidesPerView: _this.slidesPerView || 4
        };
        _this.showPagination = false;
        _this.swiperObj = {};
        
        if(ItxConfigurationSvc.isDebugActive()){
            _this.debugActive = ItxConfigurationSvc.getDebugOptions().productInfo;
        }
        
        _this.$onDestroy = () => {
            _this.destroySwiper();
        };

        _this.$onInit = () => {
            if(_this.product && !_this.product.activeDetail){
                _this.product = new Product(_this.product);
            }

            _this.layoutFourColumns = ItxConstants.categoryLayout.FOUR_COLUMNS;

            if(!_this.product || _this.product.state.conf.typeCarrousel.isDefault || _this.place === 'related'){
                _this.classTypeCarrrousel = 'carrousel-default';
            } else {
                _this.classTypeCarrrousel = 'carrousel-special';
            }

            if(!_this.selectedColor && _this.product){
                _this.selectedColor = _this.product.state.selectedColor;
            }

            if(_this.product) {
                _this.redirectBundle = _this.product.state.conf.typeCarrousel.isLook;

                _this.showViewDetails = !_this.product.state.conf.typeCarrousel.isDefault && _this.place != 'related';
            }

            var id = _this.product ? _this.product.id : Math.floor(Math.random()*(999-100+1)+100).toString();
            _this.id = _.uniqueId('box_'+id+'_');
            _this.loadSwiper();
        };

        _this.$onChanges = (changes) => {
            if ( _changeLayoutTo( changes, ItxConstants.categoryLayout.TWO_COLUMNS) ) {
                _this.loadSwiper();
            }
            if ( _changeLayoutTo( changes, ItxConstants.categoryLayout.FOUR_COLUMNS) ) {
                _this.destroySwiper();
            }
            if(changes.arrayProducts && !changes.arrayProducts.isFirstChange() && changes.arrayProducts.currentValue != changes.arrayProducts.previousValue) {
                if(_this.swiperInit){
                    _this.swiperObj.update();
                } else {
                    _this.loadSwiper();
                }
            }
        };

        function _changeLayoutTo(c,value) {
            return c.layout && !c.layout.isFirstChange() && c.layout.currentValue != c.layout.previousValue && c.layout.currentValue == value;
        }

        _this.onClick = ($event, product) => {
            if(_this.redirectBundle){
                if(!_this.selectedColor && _this.product){
                    _this.selectedColor = _this.product.state.selectedColor;
                }

                if(_this.product.state.selectedColor && _this.product.state.selectedColor.id != _this.selectedColor.id){
                    _this.product.setColor(_this.selectedColor);
                }
    
                if ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();    
                }
    
                _this.onProductClick({product: _this.product});
            } else {
                _this.onProductClick({product: product});
            }
        };

        _this.loadSwiper = () => {
            if(_this.arrayProducts.length > 4 && !_this.isMobile){
                _this.initSwiper();
            }
        };

        _this.initSwiper = () => {
            if(!_this.swiperInit){
                _this.swiperInit = true;
                _this.showPagination = !_this.slidesPerView ? _this.arrayProducts.length > 4 : _this.arrayProducts.length > _this.slidesPerView;
                _this.swiperOptions.navigation = {
                    nextEl: '#'+_this.id + ' .swiper-carrousel-next',
                    prevEl: '#'+_this.id + ' .swiper-carrousel-prev'
                };
                setTimeout(function(){
                    _this.swiperObj = new Swiper('#' + _this.id + ' .swiper-carrousel-container', _this.swiperOptions);
                },250);
            }
        };

        _this.destroySwiper = () => { 
            if(_this.swiperObj && _this.swiperInit){
                _this.swiperInit = false;
                _this.swiperObj.destroy();
            }
        };

    }

})();